<template>
  <tinymce-editor
    v-model="content"
    :init="initOptions"
  ></tinymce-editor>
</template>

<script>
import 'tinymce';
import 'tinymce/themes/silver';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/image';
import Editor from '@tinymce/tinymce-vue';

import { uploadImage, getBucketToken } from '@/apis/index';

export default {
  components: {
    'tinymce-editor': Editor,
  },
  props: {
    initialValue: String,
  },
  data() {
    return {
      content: '',
      initOptions: {
        language: 'zh_CN',
        language_url: '/tinymce/langs/zh_CN.js',
        skin_url: '/tinymce/skins/ui/oxide',
        images_upload_handler: this.uploadHandler,
        plugins: ['image', 'imagetools'],
        height: 400,
      },
    };
  },
  watch: {
    initialValue(val) {
      if (val) {
        this.content = val;
      }
    },
  },
  methods: {
    getContent() {
      const reg = /style="(.*?)"/g;

      return this.content.replace(reg, '');
    },
    uploadHandler(blobInfo, success, failure) {
      getBucketToken()
        .then(({ data }) => {
          const formData = new FormData();
          formData.append('file', blobInfo.blob());
          formData.append('Authorization', data);
          uploadImage(formData, success, failure);
        });
    },
  },
};
</script>
